import { IGroupMemberStats } from '@grassrootly/api/entities';
import { provider } from "@grassrootly/api/providers";

export interface GetMembersWithStatsParams {
  date_to: string;
  date_from: string;
  gid: number;
}

export const GetGroupMembersWithAverageRatings = async (params: GetMembersWithStatsParams):
  Promise<IGroupMemberStats[]> =>
  provider.Request("/group_players_with_avg_ratings", params);
